/*@ngInject*/
const PublishChatMessageRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.publishChatMessage = function (chatMessageId) {
        let url = '/rest/ChatMessage/' + chatMessageId + '/publish';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('publishChatMessageRepository', PublishChatMessageRepository);
